/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener("DOMContentLoaded", function () {
    // Handle btn1
    var btn1 = document.querySelector(".btn1");
    if (btn1) {
        btn1.addEventListener("click", function () {
            window.open("https://picksticks.com/collections/yummy-picks-flavor-collection", "_blank");
        });

        if (window.location.href === "https://picksticks.com/collections/yummy-picks-flavor-collection") {
            btn1.disabled = true;
        }
    }

    // Handle btn
    var btn = document.querySelector(".btn");
    if (btn) {
        btn.addEventListener("click", function () {
            window.open("https://picksticks.com/collections/caffeine-toothpicks-collection", "_blank");
        });

        if (window.location.href === "https://picksticks.com/collections/caffeine-toothpicks-collection") {
            btn.disabled = true;
        }
    }
});

// window.addEventListener("load", function () {
//   const maxHeight = 110; // px

//   document.querySelectorAll('h2.testimonials__text__text.rte p').forEach(function (el) {
//     const fullHeight = el.scrollHeight;

//     // sirf tab readmore lagao jab height 100px se zyada ho
//     if (fullHeight > maxHeight) {
//       el.classList.add("clamped-text");
//       el.style.maxHeight = maxHeight + "px";

//       const btn = document.createElement("span");
//       btn.className = "read-more-btn";
//       btn.innerText = "Read More";

//       el.parentElement.appendChild(btn); // h2 ke andar button

//       btn.addEventListener("click", function () {
//         if (el.style.maxHeight === maxHeight + "px") {
//           el.style.maxHeight = el.scrollHeight + "px";
//           btn.innerText = "Read Less";
//         } else {
//           el.style.maxHeight = maxHeight + "px";
//           btn.innerText = "Read More";
//         }
//       });
//     }
//   });
// });


function initReadMore() {
  const maxHeight = 110;

  document.querySelectorAll('h2.testimonials__text__text.rte p').forEach(function (el) {

    if (el.classList.contains("processed")) return;

    if (el.scrollHeight > maxHeight) {
      el.classList.add("clamped-text", "processed");
      el.style.maxHeight = maxHeight + "px";
      el.style.overflow = "hidden";

      const btn = document.createElement("span");
      btn.className = "read-more-btn";
      btn.innerText = "Read More";

      el.parentElement.appendChild(btn);

      btn.addEventListener("click", function () {
        if (el.style.maxHeight === maxHeight + "px") {
          el.style.maxHeight = el.scrollHeight + "px";
          btn.innerText = "Read Less";
        } else {
          el.style.maxHeight = maxHeight + "px";
          btn.innerText = "Read More";
        }
      });
    }
  });
}

/* Run multiple times to handle delayed JS */
function runReadMoreMultipleTimes() {
  setTimeout(initReadMore, 300);
  setTimeout(initReadMore, 800);
  setTimeout(initReadMore, 1500);
  setTimeout(initReadMore, 2500);
}

/* First load */
document.addEventListener("DOMContentLoaded", runReadMoreMultipleTimes);

/* Window load */
window.addEventListener("load", runReadMoreMultipleTimes);

/* Shopify section reload */
document.addEventListener("shopify:section:load", runReadMoreMultipleTimes);

/* Back button */
window.addEventListener("pageshow", runReadMoreMultipleTimes);

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("submit", function (e) {
    var form = e.target;

    if (form.classList.contains("js-search-form")) {
      var input = form.querySelector('input[name="q"]');

      if (!input.value.trim()) {
        e.preventDefault();

        // agar already message hai to dobara na banay
        if (!form.querySelector(".search-error")) {
          var error = document.createElement("p");
          error.className = "search-error-form";
          error.style.color = "red";
          error.style.marginTop = "10px";
          error.innerText = "No results found";

          form.appendChild(error);
        }
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("submit", function (e) {
    var form = e.target;

    if (form.classList.contains("search__form")) {
      var input = form.querySelector('#modal-search-input');

      if (!input.value.trim()) {
        e.preventDefault();

        // remove old error (duplicate se bachnay ke liye)
        var oldError = form.querySelector(".search-error");
        if (oldError) oldError.remove();

        var error = document.createElement("p");
        error.className = "search-error";
        error.style.color = "red";
        error.style.fontSize = "14px";
        error.innerText = "Please enter something to search.";

        // 👇 input ke baad insert karega
        input.insertAdjacentElement("afterend", error);
      }
    }
  });
});